import { render, staticRenderFns } from "./CharactersList.vue?vue&type=template&id=5fa1fab5&"
import script from "./CharactersList.vue?vue&type=script&lang=js&"
export * from "./CharactersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports